import { createSelector } from 'reselect';
import { IRootReducer } from '../../types/reducerTypes';

const stakingReducer = (state: IRootReducer) => state.staking;

export const selectStakedAmount = createSelector(
  stakingReducer,
  (reducer) => reducer.stakedAmount,
);

export const selectTier = createSelector(
  stakingReducer,
  (reducer) => reducer.tier,
);

export const selectTimeUnlock = createSelector(
  stakingReducer,
  (reducer) => reducer.timeUnlock,
);

export const selectTimeStaked = createSelector(
  stakingReducer,
  (reducer) => reducer.timeStaked,
);

export const selectTierReference = createSelector(
  stakingReducer,
  (reducer) => reducer.tierReference,
);

export const selectLockLevel = createSelector(
  stakingReducer,
  (reducer) => reducer.lockLevel,
);

export const selectStakeInformation = createSelector(
  stakingReducer,
  (reducer) => reducer.stakeInformation,
);
